<template>
  <form class="info-gerais" >
    <div class="row" v-if="cursoCarregado">
      <div class="col-md-6">
        <div class="row mt-2 mb-3">
          <div class="col-12 col-md-12">
            <div class="form-group">
              <form-group id="nomeCurso" label="Nome do curso *" :text="{ required: 'Obrigatório informar o nome do curso' }" :field="$v.curso.nome">
                <input type="text" class="form-control" id="nome" v-model="curso.nome" placeholder="Digite o nome do curso"/>
              </form-group>
            </div>
          </div>
          <div class="col-12 col-md-12">
            <div class="form-group">
              <form-group id="categoria" label="Categoria" :text="{ required: 'Obrigatório informar a categoria do curso' }" :field="$v.curso.categoria_id">
                  <select class="form-control" v-model="curso.categoria_id">
                    <option v-if="categorias.length == 0" value="">Carregando...</option>
                    <option v-if="categorias.length > 0" value="">Selecione</option>
                    <option v-for="categoria in categorias" :value="categoria.id">{{categoria.categoria}}</option>
                  </select>
              </form-group>
            </div>
          </div>
          <div class="col-12 col-md-12" v-if="curso.categoria_id == 1 && sistemasDisponiveis && sistemasDisponiveis.length > 0">
            <div class="form-group">
              <form-group id="sistema" label="Sistema" :text="{ required: 'Obrigatório informar o sistema do curso' }" :field="$v.curso.sistema_id" v-if="curso.categoria_id == 1 && sistemasDisponiveis && sistemasDisponiveis.length > 0">
                  <select class="form-control" v-model="curso.sistema_id">
                    <option v-for="sistema in sistemasDisponiveis" :value="sistema.id">{{sistema.sistema}}</option>
                  </select>
              </form-group>
            </div>
          </div>
          <div class="col-12 col-md-12"  v-if="disciplinasDisponiveis && disciplinasDisponiveis.length > 0">
            <div class="form-group">
              <form-group id="disciplina" label="Disciplina" :text="{ required: 'Obrigatório informar a disciplina do curso' }" :field="$v.curso.disciplina_id" v-if="disciplinasDisponiveis && disciplinasDisponiveis.length > 0">
                  <select class="form-control" v-model="curso.disciplina_id">
                    <option v-for="disciplina in disciplinasDisponiveis" :value="disciplina.id">{{disciplina.nome}}</option>
                  </select>
              </form-group>
            </div>
          </div>
          <div class="col-12 col-md-12">
            <form-group class="mb-2" id="planos" label="Liberar o curso para os planos:" :text="{ required: 'Obrigatório informar o(s) plano(s) do curso' }" :field="$v.curso.planos_ids">
              <div class="row mt-2">
                <div v-for="tipo_plano in tipos_planos" :value="tipo_plano.planos[0] && tipo_plano.planos[0].id" class="col-md-4">
                  <div class="form-group" v-if="tipo_plano.planos[0]">
                    <div class="input-group mb-2">
                      <div class="d-flex">
                      <input type="checkbox" class="mr-1" :id="'plano'+ tipo_plano.planos[0].id" :name="'plano'+ tipo_plano.planos[0].id" v-model="arrayPlanosIds" :value="tipo_plano.planos[0].id">
                        {{tipo_plano.nome}}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="tipos_planos.length === 0">
                  <div class="form-group">
                    <div class="input-group mb-2">
                      <div class="d-flex ml-3">
                        Carregando...
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form-group>
          </div>
          <div class="col-12">
            <div class="form-group">
              <form-group id="coordenador" label="Coordenador do Curso" :text="{ required: 'Obrigatório informar o coordenador do curso' }" :field="$v.curso.coordenador_id">
                <select class="form-control" v-model="curso.coordenador_id">
                    <option v-if="professores.length == 0" value="">Carregando...</option>
                    <option v-if="professores.length > 0" value="">Selecione</option>
                    <option v-for="professor in professores" :value="professor.id">{{professor.professor}}</option>
                  </select>
              </form-group>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <form-group id="descricao" label="Descrição" :text="{ required: 'Obrigatório informar a descrição do curso' }" :field="$v.curso.descricao">
                <textarea class="form-control" id="descricao" rows="2" v-model="curso.descricao">></textarea>
              </form-group>
            </div>
          </div>
          <div class="col-12 col-md-12">
            <div class="form-group">
              <form-group id="referencia" label="Referência *" :text="{ required: 'Obrigatório informar a referência do curso' }" :field="$v.curso.referencia">
                <input type="text" class="form-control" id="referencia" v-model="curso.referencia" placeholder="Digite a referência do curso"/>
              </form-group>
            </div>
          </div>
          <div class="col-12 col-md-12">
            <div class="form-group">
              <form-group id="ordenacao" label="Ordenação *" :text="{ required: 'Obrigatório informar a ordenação do curso' }" :field="$v.curso.ordenacao">
                <input type="number" class="form-control" id="ordenacao" v-model="curso.ordenacao" placeholder="Digite a ordenação do curso"/>
              </form-group>
            </div>
          </div>
          <div class="col-12 col-md-12">
            <div class="form-group">
              <form-group id="tipoStatus" label="Status *" :text="{ required: 'Obrigatório informar o status do curso' }" :field="$v.curso.tipo_status_curso_id">
                <div class="custom-control custom-switch status-curso-switch">
                  <input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="curso.tipo_status_curso_id" v-bind:true-value="ativo" v-bind:false-value="inativo">
                  <label class="custom-control-label" for="customSwitch1">{{ curso.tipo_status_curso_id == 1 ? 'Ativo' : 'Inativo' }}</label>
                </div>
              </form-group>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="col-md-12 mb-3" v-if="this.curso.curso_imagem && this.curso.curso_imagem.imagem">
          <p>Imagem atual do Curso</p>
          <img :src="obterUrlS3(this.curso.curso_imagem.imagem.url)" alt="" srcset="">
        </div>
        <div class="col-md-12 mb-3" v-else>
          <p>Curso sem imagem cadastrada</p>
        </div>
        <div class="col-12 col-md-12">
          <div class="form-group">
            <label for="imagemCurso">Adicionar imagem do Curso</label>
            <div class="input-group mb-3">
              <b-form-file
                v-model="curso.imagem"
                placeholder="Escolha uma imagem"
                drop-placeholder="Solte um arquivo aqui..."
                browse-text="Selecionar"
                accept="image/jpeg, image/png"
              ></b-form-file>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!cursoCarregado">
      <div class="row">
        <div class="col-md-12 mt-3">
          <h3>Carregando...</h3>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import Swal from 'sweetalert2'
import { required } from 'vuelidate/lib/validators'
import FormGroup from '@/core/components/FormGroup'
import CategoriaCursosAPI from '@/api/categorias-cursos-api'
import CursoAPI from '@/api/curso-api'
import UrlUtils from '@/core/util/url-utils'
import ProfessorAPI from '@/api/professor-api'
import ResponseUtils from '@/core/util/response-utils'

export default {
  name: 'CursoInfoGerais',
  components: {
    FormGroup
  },
  props: {
    curso_atual: Object,
    curso_edicao: Boolean,
    curso_edicao_volta: Boolean
  },
  data () {
    return {
      curso: {
        nome: '',
        disciplina_id: '',
        categoria_id: '',
        sistema_id: '',
        planos_ids: [],
        descricao: '',
        referencia: '',
        ordenacao: '',
        tipo_status_curso_id: 2,
        imagem: '',
        coordenador_id: ''
      },
      professores: [],
      disciplinas: [],
      categorias: [],
      sistemas: [],
      tipos_planos: [],
      arrayPlanosIds: [],
      ativo: 1,
      inativo: 2,
      curso_id: [],
      cursoCarregado: true
    }
  },

  computed: {
    disciplinasDisponiveis: function () {
      return this.disciplinas.filter(disciplina => (
        disciplina &&
        disciplina.categoria && disciplina.categoria.categoria_id === this.curso.categoria_id
      ))
    },

    sistemasDisponiveis: function () {
      return this.sistemas.filter(sistema => (
        sistema &&
        sistema.categoria && sistema.categoria.categoria_id === this.curso.categoria_id
      ))
    }
  },

  mounted () {
    if (this.curso_edicao) {
      this.cursoCarregado = false
      if (this.curso_edicao_volta || this.curso_atual.nome) {
        this.curso = {
          id: this.curso_atual.id,
          nome: this.curso_atual.nome,
          disciplina_id: this.curso_atual.disciplina_id,
          categoria_id: this.curso_atual.categoria_id,
          sistema_id: this.curso_atual.sistema_id,
          descricao: this.curso_atual.descricao,
          referencia: this.curso_atual.referencia,
          ordenacao: this.curso_atual.ordenacao,
          tipo_status_curso_id: this.curso_atual.tipo_status_curso_id,
          curso_ementa: this.curso_atual.curso_ementa,
          curso_imagem: this.curso_atual.curso_imagem,
          coordenador_id: this.curso_atual.coordenador_id
        }
        this.curso_atual.planos_ids.map(plano => {
          this.arrayPlanosIds.push(plano)
        })
        this.cursoCarregado = true
      } else {
        CursoAPI.listarCursoPorId(this.curso_atual.id).then(result => {
          Object.assign(this.curso_atual, result)
          this.curso = {
            id: this.curso_atual.id,
            nome: this.curso_atual.curso,
            disciplina_id: this.curso_atual.curso_disciplina && this.curso_atual.curso_disciplina.disciplina_id,
            categoria_id: this.curso_atual.curso_disciplina ? this.curso_atual.curso_disciplina.disciplina && this.curso_atual.curso_disciplina.disciplina.categoria && this.curso_atual.curso_disciplina.disciplina.categoria.categoria_id : this.curso_atual.curso_sistema.sistema && this.curso_atual.curso_sistema.sistema.categoria && this.curso_atual.curso_sistema.sistema.categoria.categoria_id,
            sistema_id: this.curso_atual.curso_sistema && this.curso_atual.curso_sistema.sistema_id,
            descricao: this.curso_atual.descricao,
            referencia: this.curso_atual.referencia,
            ordenacao: this.curso_atual.ordenacao,
            tipo_status_curso_id: this.curso_atual.tipo_status_curso_id,
            curso_ementa: this.curso_atual.curso_ementa,
            curso_imagem: this.curso_atual.curso_imagem,
            coordenador_id: this.curso_atual.curso_coordenador && this.curso_atual.curso_coordenador.coordenador.id
          }
          this.cursoCarregado = true
        })
        this.curso_atual.planos.map(plano => {
          this.arrayPlanosIds.push(plano.id)
        })
      }
      this.$nextTick(() => {
        // this.cursoCarregado = true
      })
    }

    ProfessorAPI.listar().then(data => {
      this.professores = data
    })

    CategoriaCursosAPI.listarDisciplinas().then(data => {
      this.disciplinas = data
    })

    CategoriaCursosAPI.listarCategorias().then(data => {
      this.categorias = data
    })

    CategoriaCursosAPI.listarSistemas().then(data => {
      this.sistemas = data
    })

    CategoriaCursosAPI.listarPlanos().then(data => {
      this.tipos_planos = data
    })
  },

  methods: {
    cadastrarCurso: function () {
      this.$v.curso.$touch()
      if (!this.$v.curso.$invalid) {
        const loader = this.$loading.show()

        this.curso.planos_ids = this.arrayPlanosIds

        CursoAPI.salvar(this.curso).then(data => {
          loader.hide()

          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Curso criado com sucesso'
          }).then(() => {
            this.curso_id = data
            this.$router.push({ name: 'adicionar-ementa', params: this.curso_id })
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    },

    obterUrlS3: function (arquivo) {
      if (arquivo.includes('cursos-plataforma/') !== false) {
        return UrlUtils.obterUrlS3(arquivo)
      } else {
        return UrlUtils.obterUrlS3('cursos-plataforma/' + arquivo)
      }
    },

    editarCurso: function () {
      this.$v.curso.$touch()
      if (!this.$v.curso.$invalid) {
        const loader = this.$loading.show()

        this.curso.planos_ids = this.arrayPlanosIds

        CursoAPI.editar(this.curso).then(data => {
          loader.hide()

          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Curso editado com sucesso'
          }).then(() => {
            this.curso_id = data
            this.$router.push({ name: 'adicionar-ementa',
              params: {
                curso_id: this.curso_id,
                curso_atual: this.curso,
                curso_edicao: true
              }
            })
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    }
  },

  validations: {
    curso: {
      nome: { required },
      disciplina_id: { required },
      categoria_id: { required },
      sistema_id: { },
      planos_ids: { },
      descricao: { required },
      referencia: { required },
      ordenacao: { required },
      tipo_status_curso_id: { required },
      coordenador_id: { required }
    }
  }
}
</script>
